export default __webpack_public_path__ + "static/media/card.86fe9259.webp";